import { Backdrop, CardContent } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { Card } from '../../Common/ui/card'
import { Button } from '../../Common/ui/button'
import { useTranslation } from 'react-i18next'

export const SubmitModal = ({ isOpen, setShowSubmitModal }) => {
    const { t } = useTranslation()
    return (
        <Backdrop
            sx={{ color: 'white', position: 'absolute', zIndex: 20 }}
            open={isOpen}
        >
            <Card>
                <div className='flex flex-col items-center' style={{ width: '700px' }}>
                    <CardContent className='text-xl font-medium' style={{ color: 'hsl(var(--primary))' }}>{t('Welcome !')}</CardContent>
                    <CardContent className='text-xl text-center w-[400px]'>{t('Congratulations dialog')}</CardContent>
                    <Button onClick={() => { setShowSubmitModal(false) }} className='mb-6'>{t('Get Started')}</Button>
                </div>
            </Card>
        </Backdrop>
    )
}

SubmitModal.propTypes = {
    isOpen: PropTypes.boolean,
    setShowSubmitModal: PropTypes.func
}
